<template>
  <div class="institution-form">
    <!-- 面包屑 -->
    <public-bread-crumb :routes="routes" />
    <!-- Title -->
    <h3 class="title">{{ $route.query.id ? "编辑机构" : "新增机构" }}</h3>
    <div class="main">
      <!-- Step -->
      <a-steps :current="current">
        <a-step
          :class="[hightLightStepList.includes(index) ? 'blink' : null]"
          v-for="(item, index) in steps"
          :key="item.title"
          :title="item.title"
        />
      </a-steps>
      <a-spin :spinning="formLoading">
        <div class="steps-content">
          <!-- Form -->
          <a-form
            :form="form"
            :layout="formLayout"
            :labelCol="formItemLayout.labelCol"
            :wrapperCol="formItemLayout.wrapperCol"
          >
            <div class="step-content-first" v-show="current === 0">
              <a-row>
                <a-col :span="12">
                  <a-form-item label="机构编号">
                    <a-input
                      placeholder="请输入机构编号"
                      v-decorator="[
                        'number',
                        {
                          rules: [
                            {
                              type: 'string',
                              pattern: /^.{0,10}$/,
                              message: '机构编号最多10个字符'
                            },
                            {
                              required: true,
                              message: '请输入机构编号'
                            }
                          ]
                        }
                      ]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="机构名称">
                    <a-input
                      placeholder="请输入机构名称"
                      v-decorator="[
                        'name',
                        {
                          rules: [
                            {
                              type: 'string',
                              pattern: /^.{0,20}$/,
                              message: '机构名称最多20个字符'
                            },
                            {
                              required: true,
                              message: '请输入机构名称'
                            }
                          ]
                        }
                      ]"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-item label="经纬度">
                    <a-row>
                      <a-col :span="16"
                        ><a-input
                          :disabled="true"
                          :labelCol="{ span: 10 }"
                          :wrapperCol="{ span: 14 }"
                          v-decorator="[
                            'longitudeAndLatitude',
                            {
                              initialValue: '',
                              rules: [
                                { required: false, message: '请输入经纬度' }
                              ]
                            }
                          ]"
                          placeholder="请输入经纬度"
                      /></a-col>
                      <a-col :span="8"
                        ><a-button type="primary" @click="Fun_Map" block
                          >拾取坐标
                        </a-button></a-col
                      >
                    </a-row>
                  </a-form-item>
                </a-col>
                <!-- <a-col :span="12">
                  <a-form-item label="经纬度">
                    <a-input
                      style="width: 214px"
                      :disabled="true"
                      :labelCol="{ span: 10 }"
                      :wrapperCol="{ span: 14 }"
                      v-decorator="[
                        'longitudeAndLatitude',
                        {
                          initialValue: '',
                          rules: [{ required: false, message: '请输入经纬度' }]
                        }
                      ]"
                      placeholder="请输入经纬度"
                    />
                    <a-button type="primary" @click="Fun_Map"
                      >拾取坐标
                    </a-button>
                  </a-form-item>
                </a-col> -->

                <a-col :span="12">
                  <a-form-item label="详细地址">
                    <a-input
                      placeholder="请输入详细地址"
                      v-decorator="[
                        'detailedAddress',
                        {
                          rules: [
                            {
                              type: 'string',
                              pattern: /^.{0,20}$/,
                              message: '详细地址最多20个字符'
                            },
                            {
                              required: false,
                              message: '请输入详细地址'
                            }
                          ]
                        }
                      ]"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-item label="所属区域">
                    <gl-area
                      placeholder="请选择所在区域"
                      class="item-input"
                      v-decorator="[
                        'address',
                        { rules: [{ required: true, message: '请选择区域' }] }
                      ]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="联系人">
                    <a-input
                      placeholder="请输入联系人"
                      v-decorator="[
                        'contactName',
                        {
                          rules: [
                            {
                              type: 'string',
                              pattern: /^.{0,20}$/,
                              message: '联系人最多20个字符'
                            },
                            {
                              required: true,
                              message: '请输入联系人'
                            }
                          ]
                        }
                      ]"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-item label="联系电话">
                    <a-input
                      placeholder="请输入联系电话"
                      v-decorator="[
                        'contactPhone',
                        {
                          rules: [
                            {
                              type: 'string',
                              pattern: /(^[1]([3-9])[0-9]{9}$)|\*/,
                              message: '请输入正确手机号'
                            },
                            { required: true, message: '请输入手机号码' }
                          ]
                        }
                      ]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="备注">
                    <!-- :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 21 }"
                    style="margin-left:20px;" -->
                    <a-textarea
                      v-decorator="[
                        'remark',
                        {
                          rules: [
                            {
                              type: 'string',
                              pattern: /^.{0,200}$/,
                              message: '备注最多200个字符'
                            },
                            { required: false }
                          ]
                        }
                      ]"
                      placeholder="请输入备注"
                      :rows="2"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
            </div>
            <div class="step-content-second" v-show="current === 1">
              <a-row>
                <a-col>
                  <a-form-item
                    label="服务列表"
                    :labelCol="{ span: 3 }"
                    :wrapperCol="{ span: 21 }"
                    style="margin-left:20px;"
                    required
                  >
                    <div class="list">
                      <div
                        class="list-item"
                        v-for="(item, index) in serviceList"
                        :key="index"
                        :style="{ backgroundImage: `url(${item.url})` }"
                        @click="handleItemClick(item.id)"
                      >
                        <span style="color:#fff;" v-if="item.selected">{{
                          item.name
                        }}</span>
                        <span style="color:#5862CB;" v-else>{{
                          item.name
                        }}</span>
                        <span v-show="index === 0" style="color:#fff;"
                          >(必选)</span
                        >
                      </div>
                    </div>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-item label="管理员姓名">
                    <a-input
                      placeholder="请输入管理员姓名"
                      v-decorator="[
                        'manageName',
                        {
                          rules: [
                            {
                              type: 'string',
                              pattern: /^.{0,20}$/,
                              message: '管理员姓名最多20个字符'
                            },
                            {
                              required: true,
                              message: '请输入管理员姓名'
                            }
                          ]
                        }
                      ]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="管理员手机号">
                    <a-input
                      placeholder="请输入管理员手机号"
                      v-decorator="[
                        'managePhone',
                        {
                          rules: [
                            {
                              type: 'string',
                              pattern: /(^[1]([3-9])[0-9]{9}$)|\*/,
                              message: '请输入正确手机号'
                            },
                            { required: true, message: '请输入管理员手机号码' }
                          ]
                        }
                      ]"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-item label="管理员账号">
                    <a-input
                      :disabled="$route.query.id ? true : false"
                      placeholder="请输入管理员账号"
                      v-decorator="[
                        'manageAccount',
                        {
                          rules: [
                            {
                              type: 'string',
                              pattern: /^([\da-zA-Z]){6,20}$/,
                              message: '账号格式为6-20个字母或数字'
                            },
                            {
                              required: true,
                              message: '请输入管理员账号'
                            }
                          ]
                        }
                      ]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="运维账号">
                    <a-input
                      :disabled="$route.query.id ? true : false"
                      placeholder="请输入运维账号"
                      v-decorator="[
                        'account',
                        {
                          rules: [
                            {
                              type: 'string',
                              pattern: /^([\da-zA-Z]){6,20}$/,
                              message: '账号格式为6-20个字母或数字'
                            },
                            {
                              required: true,
                              message: '请输入运维账号'
                            }
                          ]
                        }
                      ]"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-item label="运维密码">
                    <a-input
                      placeholder="请输入运维密码"
                      v-decorator="[
                        'password',
                        {
                          rules: [
                            {
                              type: 'string',
                              pattern: /^[\da-zA-Z~!@#$%^&*-=;:?._+|<>]{6,20}$/,
                              message: '密码格式为6-20个字母或数字或符号'
                            },
                            {
                              required: true,
                              message: '请输入运维密码'
                            }
                          ]
                        }
                      ]"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
            </div>
            <div
              class="step-content-third"
              v-show="current === 2"
              style="text-align:center;"
            >
              <img
                style="width:100px;height:100px;"
                src="@/assets/institution/complete.png"
                alt=""
              />
              <p style="margin-top:32px;">{{ resultText }}</p>
            </div>
          </a-form>
        </div>
      </a-spin>
      <div class="steps-action">
        <a-button v-if="current < 1" type="primary" @click="next"
          >下一步</a-button
        >
        <a-button v-if="current === 1" style="margin-left: 16px" @click="prev"
          >上一步</a-button
        >
        <a-button
          v-if="current === 1"
          type="primary"
          @click="handleSubmit"
          style="margin-left:16px;"
          :loading="btnLoading"
          >完成</a-button
        >
        <a-button
          style="margin-left: 16px"
          @click="$router.push('/institution')"
          >返回</a-button
        >
      </div>
      <map-modal
        v-if="showModal"
        :showModal="showModal"
        :modalArr="modalArr"
        @Ok="handleModalOk"
        @cancel="handleModalCancel"
      >
      </map-modal>
    </div>
  </div>
</template>

<script>
import disableBG from '@/assets/institution/bg_service_disable.png'
import activeBG from '@/assets/institution/bg_service_active.png'
import normalBG from '@/assets/institution/bg_service_normal.png'
import institutionService from '@/services/institution.service'
import { mapModal } from '../components'

export default {
  name: 'InstitutionForm',
  mounted () {
    if (this.$route.query.id) {
      this.getInfo(this.$route.query.id)
    }
  },
  components: { mapModal },
  data () {
    return {
      resultText: '添加成功',
      modalArr: {},
      showModal: false,
      form: this.$form.createForm(this, { name: 'VisitorDeviceForm' }),
      current: 0,
      formLayout: 'horizontal',
      formLoading: false,
      btnLoading: false,
      formFields: [
        [
          'number',
          'name',
          'address',
          'detailedAddress',
          'longitudeAndLatitude',
          'contactName',
          'contactPhone',
          'remark'
        ],
        ['manageName', 'managePhone', 'manageAccount', 'account', 'password']
      ],
      hightLightStepList: [],
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },
      rowLayout: {
        colSpan: 11,
        colPush: 1
      },
      routes: [
        {
          name: '机构管理',
          path: '/institution'
        }
      ],
      steps: [
        {
          title: '机构信息',
          content: 'First-content'
        },
        {
          title: '服务开通',
          content: 'Second-content'
        },
        {
          title: '完成',
          content: 'Last-content'
        }
      ],
      serviceList: [
        { id: 0, name: '基础服务', url: disableBG, selected: true },
        { id: 1, name: '门禁服务', url: normalBG, selected: false },
        { id: 2, name: '监控服务', url: normalBG, selected: false },
        { id: 3, name: '黑名单服务', url: normalBG, selected: false },
        { id: 4, name: '空间预约服务', url: normalBG, selected: false },
        { id: 5, name: '访客服务', url: normalBG, selected: false },
        { id: 6, name: '考勤服务', url: normalBG, selected: false },
        { id: 7, name: '消费服务', url: normalBG, selected: false },
        // { id: 8, name: '安全生产服务', url: normalBG, selected: false },
        { id: 9, name: '梯控服务', url: normalBG, selected: false }
      ]
    }
  },
  methods: {
    // 拾取坐标
    async Fun_Map () {
      let detailedAddressValue = await this.form.getFieldValue('name')
      this.modalArr.detailedAddressValue = detailedAddressValue
      this.modalArr.coordinates = await this.form.getFieldValue(
        'longitudeAndLatitude'
      )
      this.showModal = true
    },
    // 弹框确定
    handleModalOk (val) {
      // if (val.coordinates) {
      this.form.setFieldsValue({
        longitudeAndLatitude: val.coordinates
      })
      // }
      // if(val.addressName){
      this.form.setFieldsValue({
        detailedAddress: val.addressName
      })
      // }

      this.showModal = false
    },
    // 弹框取消
    handleModalCancel () {
      this.showModal = false
    },

    async getInfo (id) {
      this.formLoading = true
      const { status, result } = await institutionService.getInfo({
        id: id
      })
      this.formLoading = false
      if (status === 0) {
        this.serviceList = this.serviceList.map((item, index) => {
          if (index === 0) {
            return item
          } else if (result.list && result.list.includes(item.id)) {
            return {
              id: item.id,
              name: item.name,
              selected: true,
              url: activeBG
            }
          }
          return item
        })
        result.address = result.address.split('/')
        result.list = undefined
        result.time = undefined
        this.form.setFieldsValue(result)
      }
    },
    handleStepClick (index) {
      this.current = index
    },
    next () {
      this.current++
    },
    prev () {
      this.current--
    },
    handleItemClick (id) {
      const list = this.serviceList.map((item, index) => {
        if (index === 0) {
          return item
        } else if (item.id === id) {
          return {
            id: item.id,
            name: item.name,
            selected: !item.selected,
            url: !item.selected ? activeBG : normalBG
          }
        }
        return item
      })
      this.serviceList = list
    },
    handleSubmit () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          values.address = values.address.join('/')
          values.list = this.serviceList.filter(v => v.selected).map(v => v.id)
          let res = null
          this.btnLoading = true
          if (this.$route.query.id) {
            res = await institutionService.update({
              id: this.$route.query.id,
              ...values
            })
            this.resultText = '编辑成功'
          } else {
            this.resultText = '添加成功'
            res = await institutionService.add(values)
          }
          this.btnLoading = false
          if (res.status === 0) {
            this.current++
            this.$notification.success({
              message: res.result,
              description: '成功'
            })
          }
        } else {
          this.getFormFieldsStep(err)
        }
      })
    },
    // 获取当前表单验证失败字段所属步骤
    getFormFieldsStep (err) {
      let hightLightStepList = []
      Object.keys(err).forEach(item => {
        this.formFields.forEach((item1, index) => {
          if (item1.includes(item)) {
            hightLightStepList.push(index)
          }
        })
      })
      hightLightStepList = [...new Set(hightLightStepList)]
      this.hightLightStepList = []
      setTimeout(() => {
        this.hightLightStepList = hightLightStepList
      }, 100)
    }
  }
}
</script>
<style lang="less" scoped>
@keyframes blink {
  0% {
    opacity: 1;
    filter: blur(1px);
  }
  50% {
    opacity: 0;
    filter: blur(0px);
  }
  100% {
    opacity: 1;
    filter: blur(1px);
  }
}

@-webkit-keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-moz-keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-ms-keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-o-keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.institution-form {
  width: 100%;
  min-height: 870px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  /deep/.ant-steps {
    .ant-steps-item {
      cursor: pointer;
    }
    .blink {
      .ant-steps-item-title {
        color: red;
      }
      animation: blink 0.8s linear 2;
      -webkit-animation: blink 0.8s linear 2;
      -moz-animation: blink 0.8s linear 2;
      -ms-animation: blink 0.8s linear 2;
      -o-animation: blink 0.8s linear 2;
    }
  }
  .title {
    padding: 24px;
    font-size: 18px;
    font-family: MicrosoftYaHeiSemibold;
    color: rgba(88, 98, 203, 1);
    line-height: 24px;
  }
  .main {
    margin: 32px auto 0;
    width: 57%;
  }
  .steps-content {
    width: 90%;
    margin: 0 auto;
    min-width: 700px;
    margin-top: 16px;
    border-radius: 6px;
    min-height: 300px;
    padding-top: 8.3%;
    .list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .list-item {
        width: 24%;
        height: 56px;
        margin-bottom: 22px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        cursor: pointer;
        padding: 16px;
        font-size: 18px;
        font-family: MicrosoftYaHeiSemibold;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 24px;
        transition: all 0.3s;
        &:hover {
          box-shadow: 2px 3px 5px 0px rgba(196, 214, 250, 0.5);
        }
      }
    }
  }

  .steps-action {
    margin-top: 24px;
    text-align: center;
  }
}
</style>
